
import { VChip } from "vuetify/lib";

export default VChip.extend({});
